import * as React from 'react';
import { loadStripe } from '@stripe/stripe-js';

import { getAnalytics, getStripeRedirectURLs, sendButtonAnalytics } from '../../utils';
import { getDeploymentStatus } from '../../api/saas/deploymentInfo';
import { updateAppName, deleteSaasApp } from '../../api/saas/appInfo';
import { updateDeployment } from '../../api/saas/deploymentInfo';
import buyNow from '../../api/user/app/buyNow';
import SuperTokens from 'supertokens-auth-react/recipe/session';
import { createFreeInstance } from '../../api/saas/freeInstance';
import { downloadUsersCsv } from '../../api/saas/csvDownload';
import DbConnectPopup from "./dbConnectPopup"
import EnvironmentContainer from '../../components/layouts/EnvironmentContainer';
import Tabs from '../../components/elements/Tabs';
import Tab from '../../components/elements/Tab';
import DevSetupTab from '../../components/elements/SaasDevEnvTabs/DevSetupTab';
import ProdSetupTab from '../../components/elements/SaasProdEnvTabs/ProdSetupTab';
import ProdEmptySetupTab from '../../components/elements/SaasProdEnvTabs/ProdEmptySetupTab';
import DevEmptySetupTab from '../../components/elements/SaasDevEnvTabs/DevEmptySetupTab';
import ProdNoPublicAppTab from '../../components/elements/SaasProdEnvTabs/ProdNoPublicAppTab';
import ProdUsersTab from '../../components/elements/SaasProdEnvTabs/ProdUsersTab';
import saasAnalytics from './saasAnalytics';
import { getAppMAUCount } from '../../api/saas/app';

import '../../style/dashboard-saas.module.css';
import { SassAppDevData, SassAppProductionData, SaasAppListItem } from './types';
import { createApiKey } from '../../api/saas/deployment/apiKey/post';
import { deleteApiKey } from '../../api/saas/deployment/apiKey/delete';
import { TemporaryShutdown } from './temporaryShutdown';
import { CustomEventNames } from '../../constants';
import { getImagePathForRegion } from './createApp';
import { getMultitenancyAppInfo } from '../../api/saas/multi-tenancy/connection-uri-domain/get';
import { convertSaasAppDataToNewFormat } from './utils';
import { updateMultiTenancyApp } from '../../api/saas/multi-tenancy/connection-uri-domain/appid/put';
import { getMAUForMultiTenancyApp } from '../../api/saas/multi-tenancy/connection-uri-domain/appid/users/active';
import { createMultiTenancyApp } from '../../api/saas/multi-tenancy/connection-uri-domain/post';
import { addNewApiKeyForMultiTenantApp } from '../../api/saas/multi-tenancy/connection-uri-domain/appid/apikey/post';
import { removeApiKeyForMultiTenantApp } from '../../api/saas/multi-tenancy/connection-uri-domain/appid/apikey/delete';
import Storage from '../../utils/storage';
import { Spinner } from '../../useOss';
import { PaymentsModalContext } from '../../context/PaymentsModalContext';
import { PaymentsError } from '../../utils/customErrors';

const PING_INTERVAL = 2000;
export const stripePromise = (window.location.hostname === "supertokens.com" || window.location.hostname === "www.supertokens.com") ?
    loadStripe('pk_live_51H4oSgCIvXR7ZM2KifakCg83jaZb9wXba1GqzEwh5v39O2usoTELd5n7tS8C9cp51ejJCkEwsjGdE3J0BJEFHpjn0087GpvBht')
    : loadStripe('pk_test_51H4oSgCIvXR7ZM2K3PotKUtJLqk8hdyugkKNRv4hCkDzbe5cWfUR8qnqXRTcHaRYudoPEIWPDpJ79nDyiOec96cW00XGKLYcVo');// stripe testing key

interface Props {
    appDetails: SaasAppListItem,
    appList: SaasAppListItem[],
    selectApp: (appId: string) => void,
    updateAppDetails: (newAppDetails: any, type: string) => void,
    updatePricingDetails: (pricingInfo: any) => void,
    refetchAppDetails: () => void,
    resetEditState: (type: string) => void,
    clearDeploymentData: (deploymentId: string) => void
    dismissFeatureBanner: (interestedFeatures: string[]) => void
};

interface State {
    appName: string,
    appNameFocussed: boolean,
    devConfigEditMode: boolean,
    prodConfigEditMode: boolean,
    configEditErrorStatus: number,
    configEditErrorMessage: string,
    isDestroying: boolean,
    devCsvDownloading: boolean,
    prodCsvDownloading: boolean,
    devCsvError: boolean,
    prodCsvError: boolean,
    showDBConnectPopup: boolean,
    devInstanceDefaultToUsersTab: boolean,
    prodInstanceDefaultToUsersTab: boolean,
    devInstanceUsersLoading: boolean,
    prodInstanceUsersLoading: boolean,
    isCreatingProdForMultitenantApp: boolean,
    isCreatingDevForMultitenantApp: boolean,
    isSavingConfig: boolean,
};

export default class SaasApp extends React.Component<React.PropsWithChildren<Props>, State>{
    headingRef: null;
    setHeadingRef: (element: any) => void;
    timeoutId: any;
    componentIsUnmounted: boolean;
    newConfigDetails: { key: string; value: string; }[] = [];
    searchParams: any;
    isDestroyed = false;
    static contextType = PaymentsModalContext;
    context!: React.ContextType<typeof PaymentsModalContext>;

    constructor(props: React.PropsWithChildren<Props>) {
        super(props);
        this.state = {
            appName: props.appDetails.appName,
            appNameFocussed: false,
            devConfigEditMode: false,
            prodConfigEditMode: false,
            configEditErrorStatus: 0,
            configEditErrorMessage: '',
            isDestroying: false,
            devCsvDownloading: false,
            prodCsvDownloading: false,
            devCsvError: false,
            prodCsvError: false,
            showDBConnectPopup: false,
            devInstanceUsersLoading: true,
            prodInstanceUsersLoading: true,
            devInstanceDefaultToUsersTab: false,
            prodInstanceDefaultToUsersTab: false,
            isCreatingProdForMultitenantApp: false,
            isCreatingDevForMultitenantApp: false,
            isSavingConfig: false,
        }
        this.headingRef = null;
        this.setHeadingRef = (element: any) => {
            this.headingRef = element;
        };

        this.searchParams = new URLSearchParams(window.location.search);
    }

    cacheConfigValues(deploymentDetails: any) {
        this.newConfigDetails = [];
        for (let i = 0; i < deploymentDetails.config.length; i++) {
            const { keyName, value } = deploymentDetails.config[i];
            this.newConfigDetails.push({ key: keyName, value: value.toString() });
        }
    }

    async componentDidMount() {

        saasAnalytics.visitSaasDashboardAction()

        const callapi = async () => {
            let doesSessionExist = await SuperTokens.doesSessionExist()
            if (this.componentIsUnmounted || doesSessionExist === false || this.isDestroyed) {
                if (this.isDestroyed) {
                    window.location.reload()
                }
                return;
            }

            const didDeleteApp = Storage.getItem("saas-app-delete-action");

            if (didDeleteApp !== "true") {
                if (this.state.devConfigEditMode === false && this.state.prodConfigEditMode === false) {
                    try {
                        if (!this.state.isDestroying && !this.isDestroyed) {
                            if (this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.usesMultiTenancy !== true) {
                                if (this.props.appDetails.devDeployment !== undefined) {
                                    const devDeploymentStatus = await getDeploymentStatus(this.props.appDetails.appId,
                                        this.props.appDetails.devDeployment.id);
                                    this.props.updateAppDetails(devDeploymentStatus, 'dev');
                                }
        
                                // start polling the api for prod app details if the user had created a prod app
                                if (this.props.appDetails.prodDeployment !== undefined) {
                                    const prodDeploymentStatus = await getDeploymentStatus(this.props.appDetails.appId,
                                        this.props.appDetails.prodDeployment.id);
                                    this.props.updateAppDetails(prodDeploymentStatus, 'prod');
                                }
                            } else if (this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.usesMultiTenancy === true) {
                                const response = await getMultitenancyAppInfo({
                                    deploymentId: this.props.appDetails.appId,
                                });
    
                                if (response.isTemporarilyRemoved === false) {
                                    const appTouse = response.apps.filter((app) => app.appId === this.props.appDetails.appName);
    
                                    if (appTouse.length !== 0) {
                                        const mappedApp = convertSaasAppDataToNewFormat(response, appTouse[0]);
                                        
                                        if (mappedApp.isTemporarilyRemoved === false) {
                                            if (mappedApp.devDeployment !== undefined) {
                                                this.props.updateAppDetails(mappedApp.devDeployment, 'dev');
                                            }
            
                                            if (mappedApp.prodDeployment !== undefined) {
                                                this.props.updateAppDetails(mappedApp.prodDeployment, 'prod');
                                            }
                                        }
                                    }
                                }
                            }
                        }
    
                        // TODO: check if the following code is redundant as the same code is executed
                        // from lines 110-115
                        doesSessionExist = await SuperTokens.doesSessionExist()
                        if (this.componentIsUnmounted || doesSessionExist === false || this.isDestroyed) {
                            if (this.isDestroyed) {
                                window.location.reload()
                                return
                            }
                        }
                    } catch (e) {
                        if (e.message === 'Request failed with status code 400') {
                            this.isDestroyed = true
                            window.location.reload()
                            return
                        }
                    }
                }
            }
            
            this.timeoutId = setTimeout(callapi, PING_INTERVAL);
        };

        this.componentIsUnmounted = false;

        callapi();

        // get MAU count for devInstance
        if (this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.devDeployment !== undefined) {
            this.getMAUCountForInstanceAndUpdateState(this.props.appDetails.appId, this.props.appDetails.devDeployment.id, "dev", this.props.appDetails.usesMultiTenancy === true);
        }

        // get MAU count for prodInstance
        if (this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.prodDeployment !== undefined && this.doesDeploymentExist(this.props.appDetails.prodDeployment)) {
            this.getMAUCountForInstanceAndUpdateState(this.props.appDetails.appId, this.props.appDetails.prodDeployment.id, "prod", this.props.appDetails.usesMultiTenancy === true);
        }
    }

    getMAUCountForInstanceAndUpdateState = (deploymentId: string, appDeploymentId: string, instanceType: "prod" | "dev", usesMultiTenancy: boolean) => {
        if (usesMultiTenancy) {
            getMAUForMultiTenancyApp({
                appId: appDeploymentId,
                deploymentId,
                deploymentType: instanceType === "dev" ? "development" : "production",
                days: 365,
            })
            .then(response => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        [`${instanceType}InstanceDefaultToUsersTab`]: response.count > 0,
                        [`${instanceType}InstanceUsersLoading`]: false
                    }
                })
            })
        } else {
            getAppMAUCount(deploymentId, appDeploymentId, 365)
            .then((data) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        [`${instanceType}InstanceDefaultToUsersTab`]: data.count > 0,
                        [`${instanceType}InstanceUsersLoading`]: false
                    }
                })
            })
        }
    }

    // checks if a deployment has any instance, regardless of it's stopped, restarting or active status
    doesDeploymentExist = (depl: any) => {
        return depl !== undefined &&  depl.supertokensInstance !== undefined && depl.supertokensInstance.length > 0
    }

    async componentDidUpdate(prevProps: Props) {
        const didProdDeploymentExistPreviously = prevProps.appDetails.isTemporarilyRemoved !== true &&  this.doesDeploymentExist(prevProps.appDetails.prodDeployment);
        const doesProdDeploymentExistNow = this.props.appDetails.isTemporarilyRemoved !== true && this.doesDeploymentExist(this.props.appDetails.prodDeployment);

        const didDevDeploymentExistPreviously = prevProps.appDetails.isTemporarilyRemoved !== true && this.doesDeploymentExist(prevProps.appDetails.devDeployment);
        const doesDevDeploymentExistNow = this.props.appDetails.isTemporarilyRemoved !== true && this.doesDeploymentExist(this.props.appDetails.devDeployment);

        // if the prod deployment didn't exist in the last props
        // but now exists in the current props
        if (doesProdDeploymentExistNow && !didProdDeploymentExistPreviously && this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.prodDeployment !== undefined) {
            // we refetch the appDetails
            await this.props.refetchAppDetails();

            this.getMAUCountForInstanceAndUpdateState(this.props.appDetails.appId, this.props.appDetails.prodDeployment.id, "prod", this.props.appDetails.usesMultiTenancy === true);
        }

        // if the dev deployment didn't exist in the last props
        // but now exists in the current props
        if (doesDevDeploymentExistNow && !didDevDeploymentExistPreviously && this.props.appDetails.isTemporarilyRemoved !== true && this.props.appDetails.devDeployment !== undefined) {
            // we refetch the appDetails
            await this.props.refetchAppDetails();

            this.getMAUCountForInstanceAndUpdateState(this.props.appDetails.appId, this.props.appDetails.devDeployment.id, "dev", this.props.appDetails.usesMultiTenancy === true);
        }

        // We do this check for types, we dont need to worry about the app not existing before because that is already handled in the previous if conditions
        if (prevProps.appDetails.isTemporarilyRemoved === false && this.props.appDetails.isTemporarilyRemoved === false) {
            const previousState = this.getStatusText(prevProps.appDetails.prodDeployment);
            const currentState = this.getStatusText(this.props.appDetails.prodDeployment);

            if (previousState !== currentState && currentState === "Active") {
                document.dispatchEvent(new Event(CustomEventNames.dashboard.refetchActiveUsersProd));
            }
        }

        // We do this check for types, we dont need to worry about the app not existing before because that is already handled in the previous if conditions
        if (prevProps.appDetails.isTemporarilyRemoved === false && this.props.appDetails.isTemporarilyRemoved === false) {
            const previousState = this.getStatusText(prevProps.appDetails.devDeployment);
            const currentState = this.getStatusText(this.props.appDetails.devDeployment);

            if (previousState !== currentState && currentState === "Active") {
                if (previousState !== currentState && currentState === "Active") {
                    document.dispatchEvent(new Event(CustomEventNames.dashboard.refetchActiveUsersDev));
                }
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.componentIsUnmounted = true;
    }

    renderFeaturesLine(name: string) {
        return (
            <div key={name} className="feature-points">
                <img src="/static/assets/signup/Path 89200.png" />
                <div>{name}</div>
            </div>
        );
    }

    handleAppNameChange(e: any) {
        this.setState({ appName: e.target.value })
    }

    handleInputFocus() {
        this.setState({ appNameFocussed: true });
    }

    async handleSaveClick() {
        this.setState({ appNameFocussed: false });
        await updateAppName(this.props.appDetails.appId, this.state.appName);
    }

    handleAddFirstInstance() {
        buyNow(this.props.appDetails.appId);

        getAnalytics().then((stAnalytics: any) =>
            stAnalytics.sendEvent('button_saasdashboard_prod_add', {
                type: "button_click",
            }, "v1")
        );
    }

    createDevEnv = async () => {
        if (this.props.appDetails.usesMultiTenancy !== true) {
            return;
        }
        const { cancelURL, successURL } = getStripeRedirectURLs()
        return await updateMultiTenancyApp(this.props.appDetails.appName, {
            deploymentType: "development",
            deploymentId: this.props.appDetails.appId,
            config: [],
            cancelURL,
            successURL 
        })
    }

    createProductionEnv = async () => {
        if (this.props.appDetails.usesMultiTenancy !== true) {
            return await createFreeInstance(this.props.appDetails.appId);
        }
        const { cancelURL, successURL } = getStripeRedirectURLs()
        if (this.props.appDetails.appName === "public") {
            return await createMultiTenancyApp({
                deploymentType: "production",
                deploymentId: this.props.appDetails.appId,
                region: this.props.appDetails.region,
                cancelURL,
                successURL
            });
        }

        return await updateMultiTenancyApp(this.props.appDetails.appName, {
            deploymentType: "production",
            deploymentId: this.props.appDetails.appId,
            config: [],
            cancelURL,
            successURL
        })
    }

    handleCreateDev = async () => {
        this.setState({ isCreatingDevForMultitenantApp: true });
        try {
            await this.createDevEnv();
            await this.props.refetchAppDetails();
        } catch (e) {
            // ignored
        }
        this.setState({ isCreatingDevForMultitenantApp: false });
    }

    handleInitialPayNow = async () => {
        saasAnalytics.createProdEnvAction()
        this.setState({ isCreatingProdForMultitenantApp: true });
        try {
            await this.createProductionEnv();

            // refetch app details to reflect the instance creation state
            setTimeout(async()=>{
                await this.props.refetchAppDetails();
                this.setState({ isCreatingProdForMultitenantApp: false });
            },1500)

        } catch (e) {
            if(PaymentsError.isThisError(e)){
                if(this.context) {
                    saasAnalytics.paymentDetailsPopup("create-prod-app")
                    this.context.openModal({action_type:'create-prod-app',data:null,redirect_uri:e.redirectionURL,timestamp:Date.now()})
                }
            }
            this.props.updatePricingDetails({
                nextDueDate: undefined
            })
            this.setState({ isCreatingProdForMultitenantApp: false });
        }
    }

    handleEditClick(type: string, deploymentDetails: any, disableEditButton: boolean) {
        if (disableEditButton === false) {
            window.scrollTo({ top: 0 });
            this.cacheConfigValues(deploymentDetails);

            if (type === 'dev') {
                this.setState({ devConfigEditMode: true });
                saasAnalytics.editConfigAction("dev")
            } else {
                this.setState({ prodConfigEditMode: true });
                saasAnalytics.editConfigAction("prod")
            }
        }
    }

    closeEditConfig = (type: string) => {
        this.setState({ devConfigEditMode: false, prodConfigEditMode: false, configEditErrorStatus: 0, configEditErrorMessage: '' });
        this.props.resetEditState(type);
    }

    isDeploymentActive = (deployment: SassAppDevData | undefined): boolean => {
        if (deployment !== undefined && this.props.appDetails.isTemporarilyRemoved === true) {
            return false;
        }

        const supertokensInstance = getSupertokensInstance(deployment, this.props.appDetails.isTemporarilyRemoved);
        return supertokensInstance !== undefined && supertokensInstance.every(instance => instance.status === "active")
    }

    getStatusText(deployment: SassAppDevData | undefined): "Restarting" | "Stopped" | "Active" {
        const supertokensInstance = getSupertokensInstance(deployment, this.props.appDetails.isTemporarilyRemoved);
        if (supertokensInstance === undefined || supertokensInstance.length === 0) { return "Stopped" }
        return supertokensInstance.some(instance => instance.status === "restarting") ? "Restarting" : "Active";
    }

    renderDevInstance = (devDeployment?: SassAppDevData) => {
        if (this.props.appDetails.isTemporarilyRemoved === true) {
            return <></>;
        }

        if (this.props.appDetails.usesMultiTenancy !== true && devDeployment === undefined) {
            return <></>;
        }

        if (this.state.isCreatingDevForMultitenantApp) {
            return (
                <EnvironmentContainer
                    regionImage={getImagePathForRegion(this.props.appDetails.region)}
                    title="Development Environment"
                    hideStatus={true}
                    status={undefined}
                    appDetails={undefined}
                    onClearData={this.props.clearDeploymentData}
                    region={this.props.appDetails.region}
                >
                    <Tabs tabs={{ setup: "Setup" }}>
                        <Tab name="setup">
                            <h4 className="pricing-heading prod-env-creating-animation">
                                {'Creating a development environment '}
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                            </h4>
                        </Tab>
                    </Tabs>
                </EnvironmentContainer>
            );
        }

        if (devDeployment === undefined) {
            return (
                <EnvironmentContainer
                    regionImage={getImagePathForRegion(this.props.appDetails.region)}
                    title="Development Environment"
                    hideStatus={true}
                    status={undefined}
                    appDetails={undefined}
                    region={this.props.appDetails.region}
                    onClearData={this.props.clearDeploymentData}>
                        <DevEmptySetupTab
                            handleCreateEnv={() => {
                                this.handleCreateDev()
                            }}
                        />
                </EnvironmentContainer>
            );
        }

        // this operation relies on the assumption that the version number is in the format x.y (e.g 2.34)
        // so that javascript can safely coerce it for comparison
        let allowEditButton = this.isDeploymentActive(devDeployment)
        let showEditDisabledTooltip: boolean | undefined;
        let editDisabledMessage: string | undefined;

        if (this.props.appDetails.usesMultiTenancy && this.props.appDetails.appName !== "public") {
            allowEditButton = false;
            showEditDisabledTooltip = true;
        }

        if (this.props.appDetails.disableEditing === true) {
            allowEditButton = false;
            editDisabledMessage = "Editing is disabled for this app because it is undergoing maintainence."
        }

        const connectionInfo = devDeployment.connectionInfo;
        return (
            <EnvironmentContainer
                regionImage={getImagePathForRegion(this.props.appDetails.region)}
                title="Development Environment"
                status={this.getStatusText(this.props.appDetails.devDeployment)}
                appDetails={this.props.appDetails.devDeployment}
                onClearData={this.props.clearDeploymentData}
                renderChildrenBeforeTitle={() => {
                    return this.props.children
                }}
                region={this.props.appDetails.region}
            >
                <Tabs
                    loading={this.state.devInstanceUsersLoading}
                    tabs={{
                        setup: "Setup",
                        users: "Users"
                    }}
                    tabClickCallback={(tab: string) => saasAnalytics.changeTabAction("dev", tab)}
                    selectedTab={0}
                >
                    <Tab name="setup">
                        <DevSetupTab
                            appDetails={this.props.appDetails}
                            apiKeys={connectionInfo !== undefined ? connectionInfo.apiKeys : []}
                            host={connectionInfo !== undefined ? connectionInfo.host : ""}
                            editConfigDisabled={!allowEditButton}
                            showEditDisabledTooltip={showEditDisabledTooltip}
                            configButtonClickAction={() => {
                                this.handleEditClick("dev", devDeployment, !allowEditButton)
                            }}
                            accessPostgreSQLDBAction={() => {
                                saasAnalytics.accessPostgreSQLAction()
                                this.setState(oldState => ({
                                    ...oldState,
                                    showDBConnectPopup: true
                                }));
                            }}
                            visitDocsAnalytics={saasAnalytics.visitDocsAction}
                            copyCredentialCallback={saasAnalytics.copyCredentialAction}
                            connectMoreInfoCallback={() => saasAnalytics.connectMoreInfoAction("dev")}
                            createApiKeyFunction={this.createDevApiKey}
                            deleteApiKeyFunction={this.deleteDevApiKey}
                            editDisabledMessage={editDisabledMessage}
                        />
                    </Tab>
                    <Tab name="users">
                        <ProdUsersTab
                            deploymentId={this.props.appDetails.appId}
                            appDeploymentId={devDeployment.id}
                            setDaysCallback={(days: Number) => saasAnalytics.usersTabDaysCountChangeAction("dev", days)}
                            paginationLinkClickCallback={() => saasAnalytics.usersTabPaginationLinkAction("dev")}
                            activeSessionsExplanationAction={() => saasAnalytics.activeSessionsInfoModalViewAction("dev")}
                            coreVersion={devDeployment.supertokensVersion}
                            refetchEventName={CustomEventNames.dashboard.refetchActiveUsersDev}
                            deploymentType='development'
                            usesMultiTenancy={this.props.appDetails.usesMultiTenancy === true}
                        />
                    </Tab>
                </Tabs>
            </EnvironmentContainer>
        )
    }

    renderCreateProductionComponent = () => {
        if (this.props.appDetails.usesMultiTenancy !== true) {
            const app = this.props.appDetails;
            let shouldAllowCreatingProduction = app.isTemporarilyRemoved !== true;

            if (shouldAllowCreatingProduction) {
                return (
                    <ProdEmptySetupTab
                        handleCreateProdEnv={() => {
                            this.handleInitialPayNow()
                        }}
                    />
                );
            } else {
                return <></>;
            }
        }

        const publicApps = this.props.appList.filter(app => app.appName === "public");

        if (publicApps.length === 0) {
            throw new Error("Public app not found");
        }

        const publicApp = publicApps[0];

        let shouldAllowCreatingProduction = publicApp.isTemporarilyRemoved !== true && publicApp.prodDeployment !== undefined && publicApp.prodDeployment.userHadCreated === true;

        if (shouldAllowCreatingProduction || this.props.appDetails.appName === "public") {
            return (
                <ProdEmptySetupTab
                    handleCreateProdEnv={() => {
                        this.handleInitialPayNow()
                    }}
                />
            );
        }

        return <ProdNoPublicAppTab/>;
    }

    renderProductionInstances = (prodDeployment: SassAppProductionData | undefined) => {
        if (this.props.appDetails.isTemporarilyRemoved) {
            // Should never come here
            return <></>;
        }

        let allowEditButton = this.isDeploymentActive(prodDeployment);
        let showEditDisabledTooltip: boolean | undefined;

        if (this.props.appDetails.usesMultiTenancy && this.props.appDetails.appName !== "public") {
            allowEditButton = false;
            showEditDisabledTooltip = true;
        }

        const connectionInfo = prodDeployment !== undefined ? prodDeployment.connectionInfo : undefined;        

        const { apiKeys, host, serviceApiKey } = connectionInfo !== undefined ? connectionInfo : {
            apiKeys: [],
            host: "",
            serviceApiKey: ""
        };

        let displayProdInstance = this.doesDeploymentExist(prodDeployment)

        if (this.state.isCreatingProdForMultitenantApp) {
            displayProdInstance = false;
        }

        if (prodDeployment !== undefined && displayProdInstance) {  
            const envStatusText = this.getStatusText(this.props.appDetails.prodDeployment)
            let showCreditsSection = true; 
            
            if (this.props.appDetails.usesMultiTenancy === true) {
                showCreditsSection = this.props.appDetails.appName === "public";
            }
            
            return (
                <EnvironmentContainer
                    regionImage={getImagePathForRegion(this.props.appDetails.region)}
                    title="Production Environment"
                    hideStatus={apiKeys.length === 0}
                    status={envStatusText}
                    appDetails={this.props.appDetails.prodDeployment}
                    onClearData={this.props.clearDeploymentData}
                    isProductionInstance={true}
                    region={this.props.appDetails.region}
                >
                    <Tabs
                        loading={displayProdInstance && this.state.prodInstanceUsersLoading}
                        tabs={{
                            setup: "Setup",
                            users: "Users",
                        }}
                        tabClickCallback={(tab: string) => saasAnalytics.changeTabAction("prod", tab)}
                        selectedTab={0}
                    >
                        <Tab name="setup">
                            <ProdSetupTab
                                appDetails={this.props.appDetails}
                                apiKeys={apiKeys}
                                host={host}
                                serviceApiKey={serviceApiKey}
                                editConfigDisabled={!allowEditButton}
                                showEditDisabledTooltip={showEditDisabledTooltip}
                                configButtonClickAction={() =>
                                    this.handleEditClick("prod", prodDeployment, !allowEditButton)
                                }
                                copyCredentialCallback={saasAnalytics.copyCredentialAction}
                                connectMoreInfoCallback={() => saasAnalytics.connectMoreInfoAction("prod")}
                                createApiKeyFunction={this.createProdApiKey}
                                deleteApiKeyFunction={this.deleteProdApiKey}
                            />
                        </Tab>
                        <Tab name="users">
                            <ProdUsersTab
                                deploymentId={this.props.appDetails.appId}
                                appDeploymentId={prodDeployment.id}
                                setDaysCallback={(days: Number) => saasAnalytics.usersTabDaysCountChangeAction("prod", days)}
                                paginationLinkClickCallback={() => saasAnalytics.usersTabPaginationLinkAction("prod")}
                                activeSessionsExplanationAction={() => saasAnalytics.activeSessionsInfoModalViewAction("prod")}
                                coreVersion={prodDeployment.supertokensVersion}
                                refetchEventName={CustomEventNames.dashboard.refetchActiveUsersProd}
                                deploymentType='production'
                                usesMultiTenancy={this.props.appDetails.usesMultiTenancy === true}
                            />
                        </Tab>
                    </Tabs>
                </EnvironmentContainer>
            )
        } else {
            return (
                <EnvironmentContainer
                    regionImage={getImagePathForRegion(this.props.appDetails.region)}
                    title="Production Environment"
                    hideStatus
                    status={this.getStatusText(prodDeployment)}
                    appDetails={prodDeployment}
                    onClearData={this.props.clearDeploymentData}
                    isProductionInstance={true}
                    region={this.props.appDetails.region}
                >
                    <Tabs tabs={{ setup: "Setup" }}>
                        <Tab name="setup">
                            {/* userHadCreated indicates that the user has already began creating the app and it is possibly still in progress. */}
                            {(this.props.appDetails.usesMultiTenancy !== true && prodDeployment?.userHadCreated === true) || (this.props.appDetails.usesMultiTenancy === true && this.state.isCreatingProdForMultitenantApp) ? (
                                <h4 className="pricing-heading prod-env-creating-animation">
                                    {'Creating a production environment '}
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </h4>
                            ) : (
                                this.renderCreateProductionComponent()
                            )}
                        </Tab>
                    </Tabs>
                </EnvironmentContainer>
            )
        }
    }

    renderPaymentFailed() {
        if (this.searchParams.get("payment") === "failed") {
            return (
                <div key="paymentFailed" className="paper deployment">
                    <div className="error-body">
                        <h4 className="message-heading">Payment failed/ cancelled</h4>
                    </div>
                </div>
            );
        }
    }

    onConfigValueChange(index: number, value: string) {
        this.newConfigDetails[index].value = value.toString();
    }

    updateAppDeployment = async (appDetails: SaasAppListItem, deploymentDetails: any, type: "dev" | "prod") => {
        if (appDetails.isTemporarilyRemoved !== false) {
            return;
        }
        if (appDetails.usesMultiTenancy !== true) {
            await updateDeployment(appDetails.appId, deploymentDetails.id, this.newConfigDetails);
        } else {
             const { cancelURL, successURL } = getStripeRedirectURLs()

            if (type === "dev" && appDetails.devDeployment !== undefined) {
                await updateMultiTenancyApp(deploymentDetails.id, {
                    config: this.newConfigDetails,
                    deploymentId: appDetails.appId,
                    deploymentType: "development",
                    cancelURL,
                    successURL
                });
            }

            if (type === "prod" && appDetails.prodDeployment !== undefined) {
                await updateMultiTenancyApp(deploymentDetails.id, {
                    config: this.newConfigDetails,
                    deploymentId: appDetails.appId,
                    deploymentType: "production",
                    cancelURL,
                    successURL
                });
            }
        }
    }

    renderEditConfig(deploymentDetails: any, type: "dev" | "prod") {
        const handleSave = async () => {
            try {
                const { appDetails } = this.props;
                this.setState({isSavingConfig: true});
                await this.updateAppDeployment(appDetails, deploymentDetails, type);
                this.props.refetchAppDetails();
                this.closeEditConfig(type);
            } catch (e) {
                const error = e.toString();
                const status = parseInt(error.slice(error.indexOf('status code') + 12), 10);
                this.setState({ configEditErrorStatus: status, configEditErrorMessage: `Error: ${e.response.data.err}` });
            } finally {
                this.setState({isSavingConfig: false});
            }
        }

        let showMultipleAppsMessage = false;

        if (this.props.appDetails.usesMultiTenancy === true && this.props.appList.length > 1) {
            showMultipleAppsMessage = true;
        }

        return (
            <div className="saas-edit-config paper">
                <div className="top-menu">
                    <h4>Edit configuration for {type === 'dev' ? 'development environment' : 'production environment'}</h4>
                    <div className="top-menu__buttons">
                        <button
                            className="white-button"
                            onClick={() => {
                                this.closeEditConfig(type)
                                saasAnalytics.editConfigSaveGoBackAction(type, "Go back")
                            }}
                        >
                            <span>Back</span>
                        </button>
                        <button
                            className="yellow-button"
                            onClick={() => {
                                if (this.state.isSavingConfig) {
                                    return;
                                }

                                handleSave()
                                saasAnalytics.editConfigSaveGoBackAction(type, "Save")
                            }}
                        >
                            {this.state.isSavingConfig ? <Spinner isInline /> : "Save"}
                        </button>
                    </div>
                </div>
                <div className="info-blue-container" style={{ margin:"2.5rem 1.5rem 0rem 1.5rem", width:"auto" }}>
                    <span className="info-blue-pill">Note</span>
                    <p>
                        <b style={{ marginBottom:'12px' }}>For Multitenancy users:</b>
                        {showMultipleAppsMessage ? 
                            <ul>
                                <li>The configuration below affects the public tenant. All other tenants inherit their config values from these settings as well, unless a specific value is set for them. For example, if the value below for <b>password_reset_token_lifetime</b> is set to <b>3600</b>, then it will affect the <b>public</b> tenant, and any other tenant that has not specifically set a value for <b>password_reset_token_lifetime</b> for itself. You can configure tenant specific values by seeing <a href="/docs/multitenancy/new-tenant#providing-additional-configuration-per-tenant" target='_blank'> this page.</a></li>
                                <li>Since you have multiple apps, the values below will affect other apps in {type === 'dev' ? 'development environment' : 'production environment'} as well, unless you set a specific value for that app. You can see how to set specific values for an app on<a href="/docs/multitenancy/new-app#create-a-new--update-an-app-in-the-core" target='_blank'> this link</a>.</li>
                            </ul>
                        : 
                            <>
                                <br/>
                                The configuration below affects the public tenant. All other tenants inherit their config values from these settings as well, unless a specific value is set for them. For example, if the value below for <b>password_reset_token_lifetime</b> is set to <b>3600</b>, then it will affect the <b>public</b> tenant, and any other tenant that has not specifically set a value for <b>password_reset_token_lifetime</b> for itself. You can configure tenant specific values by seeing <a href="/docs/multitenancy/new-tenant#providing-additional-configuration-per-tenant" target='_blank'> this page.</a>
                            </>
                        }
                    </p>
                </div>
                <div className="saas-edit-config__content">
                    {this.state.configEditErrorStatus > 0 &&
                        <p style={{ marginBottom: '16px', color: '#FA4A3D' }}>
                            {this.state.configEditErrorStatus === 400 ? this.state.configEditErrorMessage :
                                'Something went wrong, try saving again'}
                        </p>
                    }
                    <div className="config-grid">
                        {deploymentDetails.config.map((config: any, index: number) => (
                            <div key={config.keyName} className="config-card">
                                <h6>{config.keyName}</h6>
                                <input className="value-input"
                                    type="text"
                                    defaultValue={config.value}
                                    onChange={(e) => this.onConfigValueChange(index, e.target.value)}
                                />
                                <p style={{ whiteSpace: 'pre-wrap' }}>{config.description}</p>
                            </div>
                        ))}
                    </div>
                    {this.state.configEditErrorStatus > 0 &&
                        <p style={{ marginBottom: '16px', color: '#FA4A3D' }}>
                            {this.state.configEditErrorStatus === 400 ? this.state.configEditErrorMessage :
                                'Something went wrong, try saving again'}
                        </p>
                    }

                    <div className="bottom-menu">
                        <button
                            className="white-button"
                            onClick={() => {
                                this.closeEditConfig(type)
                                saasAnalytics.editConfigSaveGoBackAction(type, "Go back")
                            }}
                        >
                            <span>Back</span>
                        </button>
                        <div
                            className="yellow-button"
                            onClick={() => {
                                if (this.state.isSavingConfig) {
                                    return;
                                }

                                handleSave()
                                saasAnalytics.editConfigSaveGoBackAction(type, "Save")
                            }}
                        >
                            {this.state.isSavingConfig ? <Spinner isInline /> : "Save"}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleSaasAppDelete = async () => {
        this.setState((oldState) => {
            return {
                ...oldState,
                isDestroying: true
            }
        })
        await deleteSaasApp(this.props.appDetails.appId);
        this.isDestroyed = true
    }

    renderTemporaryShutdown() {
        const { appId, appName } = this.props.appDetails;
        return <div className="saas-container temporary-shutdown" data-appid={appId} data-appname={appName}>
        <div className="centered-box centered-box-temporary-shutdown">
            <TemporaryShutdown refetchAppDetails={this.props.refetchAppDetails} appId={appId}/>
            </div>
        </div>
    }

    render() {        
        const _isTemporarilyRemoved = this.props.appDetails.isTemporarilyRemoved;

        if (_isTemporarilyRemoved) {
            return this.renderTemporaryShutdown()
        }

        const { dismissFeatureBanner } = this.props;
        const { devDeployment, prodDeployment } = this.props.appDetails;

        return (
            <div className="centered-box">
                {(!this.state.devConfigEditMode && !this.state.prodConfigEditMode) ?
                    <>
                        {this.renderDevInstance(devDeployment)}
                        {this.renderPaymentFailed()}
                        {this.renderProductionInstances(prodDeployment)}
                    </>
                    :
                    this.state.devConfigEditMode ?
                        this.renderEditConfig(devDeployment, 'dev')
                        :
                        this.renderEditConfig(prodDeployment, 'prod')
                }
                {this.state.showDBConnectPopup && devDeployment !== undefined &&
                    <DbConnectPopup
                        closeConnectPopup={() => {
                            this.setState(oldState => ({
                                ...oldState,
                                showDBConnectPopup: false
                            }));
                        }}
                        appDeploymentId={devDeployment.id}
                        deploymentId={this.props.appDetails.appId}
                        copyClickCallback={saasAnalytics.accessPostgreSQLCopyAction}
                        usesMultiTenancy={this.props.appDetails.usesMultiTenancy === true}
                    />
                }
            </div>
        );
    }

    createNewApiKey = async (deploymentId: string, appDeploymentId: string, deploymentType: "development" | "production") => {
        if (this.props.appDetails.usesMultiTenancy !== true) {
            return await createApiKey(deploymentId, appDeploymentId)
        }

        return await addNewApiKeyForMultiTenantApp({
            appId: appDeploymentId,
            deploymentId,
            deploymentType,
        })
    }

    removeApiKeyFromApp = async (deploymentId: string, appDeploymentId: string, deploymentType: "development" | "production", apiKey: string) => {
        if (this.props.appDetails.usesMultiTenancy !== true) {
            return deleteApiKey(deploymentId, appDeploymentId, apiKey)
        }

        return await removeApiKeyForMultiTenantApp({
            appId: appDeploymentId,
            deploymentId,
            deploymentType,
            apiKey,
        })
    }

    createDevApiKey = async () => {
        if (this.props.appDetails.isTemporarilyRemoved === true || this.props.appDetails.devDeployment === undefined) {
            return {};
        }

        const {appId, devDeployment } = this.props.appDetails

        return this.createNewApiKey(appId, devDeployment.id, "development")
    }

    deleteDevApiKey = async (apiKey: string) => {
        if (this.props.appDetails.isTemporarilyRemoved === true || this.props.appDetails.devDeployment === undefined) {
            return {};
        }

        const {appId, devDeployment } = this.props.appDetails

        return this.removeApiKeyFromApp(appId, devDeployment.id, "development", apiKey)
    }
    
    createProdApiKey = async () => {
        if (this.props.appDetails.isTemporarilyRemoved === true || this.props.appDetails.prodDeployment === undefined) {
            return {};
        }

        const {appId, prodDeployment } = this.props.appDetails

        return this.createNewApiKey(appId, prodDeployment.id, "production")
    }

    deleteProdApiKey= async (apiKey: string) => {
        if (this.props.appDetails.isTemporarilyRemoved === true || this.props.appDetails.prodDeployment === undefined) {
            return {};
        }

        const {appId, prodDeployment } = this.props.appDetails

        return this.removeApiKeyFromApp(appId, prodDeployment.id, "production", apiKey)
    }
};

const getSupertokensInstance = (deployment: SassAppDevData | undefined, isTemporarilyRemoved: boolean) => {
    return deployment !== undefined && isTemporarilyRemoved !== true ? deployment.supertokensInstance : undefined;
}
